import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedComponentsModule } from './shared/modules/shared-components/shared-components.module';  
import { CcnChimeModule } from './pages/ccn-chime/ccn-chime.module';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent 
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedComponentsModule.forRoot(),
    CcnChimeModule,
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
